import React, { FC, memo } from 'react';
import classnames from 'classnames';
import twemoji from 'twemoji';
import { Markdown } from '@src/components/Markdown';
import { MessageBubbleProps } from './props';
import './styles.scss';

twemoji.ext = '.svg';
twemoji.size = 'svg';

export const MessageBubble: FC<MessageBubbleProps> = memo(({ text, hasAccent, isInvisible }) => {
  const className = classnames(
    'fr-message__bubble',
    hasAccent && 'fr-message__bubble--accent',
    isInvisible && 'fr-message__bubble--invisible',
  );

  return <Markdown markdown={twemoji.parse(text)} wrapperClassName={className} />;
});
